import { NavLink, Link } from 'react-router-dom';
import type { AppState, AuthUser } from '../hooks/useApp.ts';

interface Props {
  state: AppState;
  onSignIn: () => void;
  onSignOut: () => void;
}

export function Header({ state, onSignIn, onSignOut }: Props): JSX.Element {
  return (
    <header className="site-header">
      <div className="header-row">
        <Link to="/" className="brand">
          <div className="logo" />
          <div className="name">how to python<span className="dot">.</span></div>
        </Link>
        <nav className="nav-links">
          <NavLink to="/category/tutorial">Tutorials</NavLink>
          <NavLink to="/category/project">Projects</NavLink>
          <NavLink to="/category/curiosity">Curiosities</NavLink>
          <NavLink to="/category/qa">Q&amp;A</NavLink>
          <NavLink to="/category/cheatsheet">Cheatsheets</NavLink>
          <NavLink to="/category/library">Libraries</NavLink>
          <NavLink to="/roadmap">Roadmap</NavLink>
          <NavLink to="/stats">Stats</NavLink>
        </nav>
        <div className="header-meta">
          <PresencePill online={state.online} conn={state.conn} />
          <span className="meta-pill" title="Site version">
            <span className="ver">v{state.version}</span>
          </span>
          <UserMenu user={state.user} onSignIn={onSignIn} onSignOut={onSignOut} />
        </div>
      </div>
    </header>
  );
}

function PresencePill({ online, conn }: { online: number; conn: AppState['conn'] }): JSX.Element {
  const offline = conn !== 'open';
  return (
    <span className={`meta-pill${offline ? ' offline' : ''}`} title={offline ? 'Reconnecting…' : `${online} online`}>
      <span className="live-dot" />
      <span>{online} online</span>
    </span>
  );
}

function UserMenu({ user, onSignIn, onSignOut }: { user: AuthUser | null; onSignIn: () => void; onSignOut: () => void }): JSX.Element {
  if (user) {
    return (
      <div className="user-menu">
        <span className="greet">@{user.username}</span>
        <button onClick={onSignOut}>Sign out</button>
      </div>
    );
  }
  return (
    <div className="user-menu">
      <button className="primary" onClick={onSignIn}>Sign in</button>
    </div>
  );
}
